import './main.css';
import heroBg from '../../assets/mockup/hero_bg.jpg';

function Main() {
  const motto = ['HEALTH', 'SAFETY', 'TRUST'];

  return (
    <section className="hero" id="home" aria-label="BeoMedica">
      <div className="hero__backdrop" aria-hidden="true">
        <img className="hero__photo" src={heroBg} alt="" />
        <div className="hero__wash" />
      </div>

      <div className="hero__content bm-container">
        <div className="hero__stage">
          <div className="hero__type">
            <img
              className="hero__logo"
              src={`${process.env.PUBLIC_URL}/BEOMEDICA_Logo.png`}
              alt="BeoMedica"
              width="420"
              height="184"
            />

            <p className="hero__motto" aria-label="Health Safety Trust">
              {motto.map((word, index) => (
                <span key={word} className="hero__motto-word">
                  <span className="hero__motto-inner" style={{ '--i': index }} aria-hidden="true">
                    {word}
                  </span>
                  {index < motto.length - 1 && (
                    <span className="hero__dash" aria-hidden="true">
                      —
                    </span>
                  )}
                </span>
              ))}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Main;
